import { Table, TableCell, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AssetTable = styled(Table)(() => ({
  width: '100%',
  borderCollapse: 'separate',
  borderSpacing: '0 1px',
  tableLayout: 'fixed',
}));

export const AssetTableRow = styled(TableRow)(({ theme }) => ({
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export const AssetTableCell = styled(TableCell)(({ theme }) => ({
  border: 'none',
  borderBottom: `1px solid ${theme.palette.divider}`,
  overflow: 'hidden',
}));

export const AssetTableCellLabel = styled(AssetTableCell)(({ theme }) => ({
  padding: theme.spacing(1, 0, 1, 1),
  fontWeight: 'normal',
  width: '35%',
}));

export const AssetTableCellValue = styled(AssetTableCell)(({ theme }) => ({
  padding: theme.spacing(1, 1, 1, 0),
  width: '65%',
}));
